const PhoneFormatter = input => {
  if (input == null) return input;

  //alert(input);
  input = input.replace(/\D/g, "");

  // Trim the remaining input to ten characters, to preserve phone number format
  input = input.substring(0, 10);

  // Based upon the length of the string, we add formatting as necessary
  var size = input.length;
  if (size == 0) {
    //
  } else if (size < 4) {
    input = "(" + input;
  } else if (size < 7) {
    input = "(" + input.substring(0, 3) + ") " + input.substring(3, 6);
  } else {
    input =
      "(" + input.substring(0, 3) + ") " + input.substring(3, 6) + " - " + input.substring(6, 10);
  }
  return input;
};

const SSNFormatter = input => {
  if (input == null) return input;
  //alert(input);
  input = input.replace(/\D/g, "");

  // Trim the remaining input to ten characters, to preserve zip format
  input = input.substring(0, 9);

  // Based upon the length of the string, we add formatting as necessary
  var size = input.length;
  if (size == 0) {
    //
  } else if (size < 3) {
    input = "" + input + "-";
  } else if (size < 5) {
    input = "" + input.substring(0, 3) + "-" + input.substring(3, 5) + "-";
  } else {
    input = "" + input.substring(0, 3) + "-" + input.substring(3, 5) + "-" + input.substring(5, 9);
  }
  return input;
};

const ZipFormatter = input => {
  if (input == null) return input;
  //alert(input);
  input = input.replace(/\D/g, "");
  // Trim the remaining input to ten characters, to preserve Zip format
  input = input.substring(0, 9);
  // Based upon the length of the string, we add formatting as necessary
  var size = input.length;
  if (size == 0) {
    //
  } else if (size <= 5) {
    input = "" + input;
  } else {
    input = "" + input.substring(0, 5) + "-" + input.substring(5, 9);
  }
  return input;
};

const YNBooleanFormatter = value => {
  if (value === "true" || value === "Y" || value === true) {
    return "Yes";
  } else {
    return "No";
  }
};

const ZipValidator = sZip => {
  return /^\d{5}(-\d{4})?$/.test(sZip);
};

export { PhoneFormatter, ZipFormatter, SSNFormatter, ZipValidator, YNBooleanFormatter };
